// extracted by mini-css-extract-plugin
export default {"botoneraCuadroDatos":"CuadroTablaInsertable_botoneraCuadroDatos__Mp2H1","botonCuadroDatos":"CuadroTablaInsertable_botonCuadroDatos__3t9qA"};